import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const LoanStepList = () => {
  const [steps, setSteps] = useState([]);
  const token = sessionStorage.getItem("authToken");
  const navigate = useNavigate();

  const fetchSteps = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getAllLoanStep`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setSteps(res.data.steps || []);
    } catch (err) {
      console.error("Error fetching loan steps:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this step?")) return;
    try {
      await axios.delete(`${COMMON_API}/loan/deleteLoanStep/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("Step deleted successfully");
      fetchSteps();
    } catch (err) {
      console.error("Error deleting step:", err);
      alert("Failed to delete");
    }
  };

  useEffect(() => {
    fetchSteps();
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 max-w-6xl mx-auto">
        <div className="flex justify-between mb-4">
          <h2 className="text-2xl font-bold">Loan Steps</h2>
          <button
            onClick={() => navigate("/add-loan-step")}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Add Step
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-4 py-2">ID</th>
                <th className="border px-4 py-2">Image</th>
                <th className="border px-4 py-2">Title</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {steps.map((s) => (
                <tr key={s.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{s.id}</td>
                  <td className="border px-4 py-2">
                    {s.image && (
                      <img
                        src={`${COMMON_API}/ImgUploads/${s.image}`}
                        alt="step"
                        className="w-16 h-12 object-cover rounded"
                      />
                    )}
                  </td>
                  <td className="border px-4 py-2">{s.title}</td>
                  <td className="border px-4 py-2 space-x-2">
                    
                    <button
                      onClick={() => navigate(`/edit-loan-step/${s.id}`)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(s.id)}
                      className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {steps.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center py-3 text-gray-500">
                    No steps found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LoanStepList;
